import * as React from 'react';
import {GridPaginationModel} from '@mui/x-data-grid';
import BatchWavingService from '../../../shared/services/BatchWavingService';
import {BatchProgressViewmodel} from '../WaveBatchInterfaces';
import {Wave} from '../WaveInterfaces';
import {Shipment} from '../../outbound-shipments/ShipmentInterfaces';

export interface TWaveDetailsContext {
  authenticityToken: string;
  batchesCount: number;
  batchWavingService: BatchWavingService;
  batchesPaginationModel: GridPaginationModel;
  setBatchesPaginationModel: (model: GridPaginationModel) => void;
  isLoading: boolean;
  wave: Wave;
  batches: BatchProgressViewmodel[];
  shipments: Shipment[];
}

export const WaveDetailsContext = React.createContext<TWaveDetailsContext>({
  authenticityToken: '',
  batchesCount: 0,
  batchWavingService: null,
  batchesPaginationModel: {
    page: 0,
    pageSize: 50
  },
  setBatchesPaginationModel: null,
  isLoading: false,
  wave: null,
  batches: [],
  shipments: []
});
